import { useMutation, useQueryClient } from "@tanstack/react-query";
import { payInvoice } from "@/api/v1-jwt/transaction/transaction";

export function usePayInvoice() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: payInvoice,
    onMutate: async (payload) => {
      await queryClient.cancelQueries({ queryKey: ["invoices"] });

      const invoices = queryClient.getQueryData(["invoices"]) || [];
      const optimistic = invoices.map((inv) => {
        if (inv.invoice_id !== payload.invoice_id) {
          return inv;
        }

        return {
          invoice_id: inv.invoice_id,
          invoice_info: {
            ...inv.invoice_info,
            invoice_status: "Pending",
          },
        };
      });

      queryClient.setQueryData(["invoices"], optimistic);
      return { invoices, payload }; // Return context for onError
    },
    onError: (_err, _, context) => {
      queryClient.setQueryData(["invoices"], context.invoices);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["invoices"] });
    },
  });
}
